import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisplaySlotDto } from '../../../../../api/gen';
import { DisplaySlotType } from '../../../../../api/gen/model/displaySlotType';

@Component({
  selector: 'app-slot-edit-item',
  standalone: true,
  imports: [FormsModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule, MatTooltipModule],
  templateUrl: './slot-edit-item.component.html',
  styleUrl: './slot-edit-item.component.scss'
})
export class SlotEditItemComponent {
  @Input() slot!: Partial<DisplaySlotDto>;
  @Input() index!: number;
  @Input() slotTypes: DisplaySlotType[] = [];
  @Input() pendingImageFile: File | null = null;

  @Output() fieldChange = new EventEmitter<{ field: keyof DisplaySlotDto; value: unknown }>();
  @Output() remove = new EventEmitter<void>();
  @Output() imageFileSelected = new EventEmitter<File | null>();

  isImageSlot(): boolean {
    return this.slot?.slotType === DisplaySlotType.Image
      || this.slot?.slotType === DisplaySlotType.ImageWithOverlayText;
  }

  isImageWithOverlayText(): boolean {
    return this.slot?.slotType === DisplaySlotType.ImageWithOverlayText;
  }

  hasValueField(): boolean {
    return this.slot?.slotType === DisplaySlotType.StaticText
      || this.slot?.slotType === DisplaySlotType.DynamicText;
  }

  getValueLabel(): string {
    return this.slot.slotType === DisplaySlotType.DynamicText ? 'Dynamic Value' : 'Value';
  }

  getValuePlaceholder(): string {
    return this.slot.slotType === DisplaySlotType.DynamicText
      ? 'e.g. {plate} or {expiry}'
      : 'Enter static text';
  }

  onFileChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0] ?? null;
    this.imageFileSelected.emit(file);
    (event.target as HTMLInputElement).value = '';
  }
}
